import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import '../../../assets/css/dist/planos.dist.css';

const TableSanfonaRentabilidate = (props: any) => {

  const [table, setTable] = useState<any[]>([]);

  // Id da Tabela
  const { v4: uuidv4 } = require('uuid');
  const id = uuidv4();

  useEffect(() => {
    api
      .get(props.page)
      .then((response) => {
        setTable(response.data);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, [props.page]);

  return (

    <div className="_accordion d-lg-block">
      <div className="tabs">
        {table?.map((item, index) => (
          <div key={index} className="tab mb-2" >
            <input type="checkbox" id={id + index} className="inpt-check" name="perguntas" />
            <label className="tab-label mb-0" htmlFor={id + index}> {item.title} </label>
            <div className="tab-content">
              <div className="table">

                <table className="mb-4 text-center" >
                  <thead>
                    <tr className="">
                      <td className="" rowSpan={2}>Período
                      </td>
                      <td className="d-none d-lg-table-cell" colSpan={2}>UltraConservador
                      </td>
                      <td className="d-none d-lg-table-cell" colSpan={2}>Conservador
                      </td>
                      <td className="d-none d-lg-table-cell" colSpan={2}>Moderado
                      </td>
                      <td className="d-none d-lg-table-cell" colSpan={2}>Agressivo
                      </td>
                      <td className="" rowSpan={2}>Notas Explicativas
                      </td>
                    </tr>
                    <tr className="ms-rteTableHeaderRow-6">
                      <td className="d-none d-lg-table-cell minor">Mês (%)</td>
                      <td className="d-none d-lg-table-cell minor" >Acumulado (%)</td>
                      <td className="d-none d-lg-table-cell minor">Mês (%)</td>
                      <td className="d-none d-lg-table-cell minor">Acumulado (%)</td>
                      <td className="d-none d-lg-table-cell minor">Mês (%)</td>
                      <td className="d-none d-lg-table-cell minor">Acumulado (%)</td>
                      <td className="d-none d-lg-table-cell minor">Mês (%)</td>
                      <td className="d-none d-lg-table-cell minor">Acumulado (%)</td>
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative", padding: "20px", minHeight: "250%", overflow: "visible" }}>

                    {item.data.map((i: any, d: any) => (

                      <tr key={d} >
                        <td> {i.mes} </td>
                        <td className="d-none d-lg-table-cell"> {i.UltraConservadorMes} </td>
                        <td className="d-none d-lg-table-cell"> {i.UltraConservadorAcum} </td>
                        <td className="d-none d-lg-table-cell"> {i.ConservadorMes} </td>
                        <td className="d-none d-lg-table-cell"> {i.ConservadorAcum} </td>
                        <td className="d-none d-lg-table-cell"> {i.ModeradoMes} </td>
                        <td className="d-none d-lg-table-cell"> {i.ModeradoAcum} </td>
                        <td className="d-none d-lg-table-cell"> {i.AgressivoMes} </td>
                        <td className="d-none d-lg-table-cell"> {i.AgressivoAcum} </td>
                        <td >
                          {i?.URL && <a rel="noreferrer" href={i.URL} target="_blank">
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 10H13L9 14L5 10H8V6H10V10ZM12 2H2V18H16V6H12V2ZM0 0.992C0 0.444 0.447 0 0.999 0H13L18 5V18.993C18.0009 19.1243 17.976 19.2545 17.9266 19.3762C17.8772 19.4979 17.8043 19.6087 17.7121 19.7022C17.6199 19.7957 17.5101 19.8701 17.3892 19.9212C17.2682 19.9723 17.1383 19.9991 17.007 20H0.993C0.730378 19.9982 0.479017 19.8931 0.293218 19.7075C0.107418 19.5219 0.00209465 19.2706 0 19.008V0.992Z" fill="#E87400" />
                            </svg>
                          </a>}
                        </td>
                      </tr>

                    ))}

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TableSanfonaRentabilidate;